import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import DataObject from './index.js';

var ColorScale = /*#__PURE__*/function (_DataObject) {
  _inherits(ColorScale, _DataObject);

  var _super = _createSuper(ColorScale);

  function ColorScale() {
    var _this;

    _classCallCheck(this, ColorScale);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "colors", ['#f55d6e', // Not achieved
    '#1bd308', // Lowest
    '#1ede34', '#23de96', '#12d3ad', '#2bbbc1', // Middle
    '#179bbc', '#1e87b5', '#1e6fb5', '#0b5ca8' // Highest
    ]);

    return _this;
  }

  _createClass(ColorScale, [{
    key: "get",
    value: function get() {
      var addRed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var size = this.data;

      if (addRed) {
        size = size - 1;
      }

      var result = [];

      if (size == 1) {
        result = [this.colors[1]];
      }

      if (size == 2) {
        result = [this.colors[1], this.colors[9]];
      }

      if (size == 3) {
        result = [this.colors[1], this.colors[5], this.colors[9]];
      }

      if (size == 4) {
        result = [this.colors[1], this.colors[5], this.colors[7], this.colors[9]];
      }

      if (size == 5) {
        result = [this.colors[1], this.colors[3], this.colors[5], this.colors[7], this.colors[9]];
      }

      if (size == 6) {
        result = [this.colors[1], this.colors[3], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }

      if (size == 7) {
        result = [this.colors[1], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }

      if (size == 8) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }

      if (size == 9) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[7], this.colors[8], this.colors[9]];
      }

      if (size > 9) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[7], this.colors[8], this.colors[9]];
        var needed = size - 9;

        for (var i = 0; i < needed; i++) {
          result.push(this.colors[9]);
        }
      }

      if (addRed) {
        result.unshift(this.colors[0]);
      }

      return result;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.colors;
    }
  }]);

  return ColorScale;
}(DataObject);

export default ColorScale;